export default function SvgTick(props) {
    return (
        <svg {...props} viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.659 0.865565L3.85359 8.19267L5.31901 9.55375L12.1244 2.22665L10.659 0.865565ZM0.372565 5.02993L4.95877 9.21911L6.30762 7.74243L1.72142 3.55324L0.372565 5.02993Z"
                fill="currentColor"/>
        </svg>
    )
}